import styled, { css } from 'styled-components'

export const Container = styled.div`
  margin-top: 24px;
`

export const Label = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xsmall};
    margin-bottom: 5px;
    text-transform: capitalize;
    color: ${theme.colors.title};
  `}
`

export const Content = styled.div`
  ${({ theme }) => css`
    margin-bottom: 15px;
    width: 100%;
    min-height: 85px;
    background-color: ${theme.colors.background_light};
    border-radius: 10px;

    display: flex;
    justify-content: space-between;
  `}
`

export const WrapperCard = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  padding: 15px;
`

export const Line = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 1px;
    background-color: ${theme.colors.border};
    margin: 15px 0;
  `}
`

export const WrapperActions = styled.div`
  ${({ theme }) => css`
    min-width: 47px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: ${theme.colors.background_light};

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `}
`
